// Two stacked CSS triangles produce a bordered arrow notch — outer uses
// --color-smoke, inner uses --color-white to fake a 1px border ring.

/** Points upward; sits at the top edge of the card. `left` aligns with the target element's center. */
export function UpArrowNotch({ left }: { left: number }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        top: -9,
        left,
        width: 0,
        height: 0,
        borderLeft: "9px solid transparent",
        borderRight: "9px solid transparent",
        borderBottom: "9px solid var(--color-smoke)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 1,
          left: -8,
          width: 0,
          height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderBottom: "8px solid var(--color-white)",
        }}
      />
    </div>
  );
}

/** Points rightward; sits at the right edge of the card, vertically centered. */
export function RightArrowNotch() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        top: "50%",
        right: -9,
        transform: "translateY(-50%)",
        width: 0,
        height: 0,
        borderTop: "9px solid transparent",
        borderBottom: "9px solid transparent",
        borderLeft: "9px solid var(--color-smoke)",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 1,
          top: -8,
          width: 0,
          height: 0,
          borderTop: "8px solid transparent",
          borderBottom: "8px solid transparent",
          borderLeft: "8px solid var(--color-white)",
        }}
      />
    </div>
  );
}
